import { nonNull } from '@helpers/non-null';

export function download(
  url: URL | string | null | undefined,
  fileName?: string | undefined
) {
  if (!url) return;
  const link = document.createElement('a');
  link.href = url.toString();
  link.download = fileName ?? '';
  link.target = '_blank';
  link.click();
  link.remove();
}

export function downloadImage(
  url: URL | string | null | undefined,
  fileName?: string | undefined
) {
  if (!url) return;
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName ?? '';
      link.click();
      URL.revokeObjectURL(link.href);
    });
}

export function downloadAll(
  urls: Array<URL | string | null | undefined>,
  fileName?: string
) {
  const nonNullUrls = urls.filter((x) => !!x).map((x) => nonNull(x));
  if (!nonNullUrls.length) return;
  if (nonNullUrls.length === 1) {
    download(nonNullUrls[0]);
    return;
  }

  // using service-worker to merge all files into zip archive
  const form = document.createElement('form');
  form.method = 'GET';
  form.action = `/download-all/${fileName ?? 'files.zip'}`;
  form.style.display = 'none';
  for (const url of nonNullUrls) {
    const input = document.createElement('input');
    input.name = 'url';
    input.value = url.toString();
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
  form.remove();
}
